import { render } from "./SelectedPage.vue?vue&type=template&id=4a67c1c4"
import script from "./SelectedPage.vue?vue&type=script&lang=js"
export * from "./SelectedPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__